// extracted by mini-css-extract-plugin
export default {"root":"InProgressTable_root__gPjmd","bottomSection":"InProgressTable_bottomSection__lVEC7","bottomSectionLabel":"InProgressTable_bottomSectionLabel__r1UIU"};